import { render, staticRenderFns } from "./ButtonAssignRoles.vue?vue&type=template&id=5d9402c7&"
import script from "./ButtonAssignRoles.vue?vue&type=script&lang=js&"
export * from "./ButtonAssignRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports